import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface BulkBillingCodeEntry {
  matter_id: string;
  new_billing_code: string;
}

export interface BulkBillingCodeRequest {
  entries: BulkBillingCodeEntry[];
}

export interface PreviewChangeItem {
  matter_id: string;
  matter_name: string;
  firm_name: string;
  current_billing_code: string;
  new_billing_code: string;
}

export interface PreviewInvalidItem {
  matter_id: string;
  new_billing_code: string;
  reason: string;
}

export interface PreviewSummary {
  total_entries: number;
  will_change: number;
  already_correct: number;
  invalid_codes: number;
  invalid_ids: number;
  not_found: number;
}

export interface PreviewResponse {
  changes: PreviewChangeItem[];
  already_correct: PreviewChangeItem[];
  invalid_codes: PreviewInvalidItem[];
  invalid_ids: PreviewInvalidItem[];
  not_found: PreviewInvalidItem[];
  summary: PreviewSummary;
}

export interface ApplyError {
  matter_id: string;
  error: string;
}

export interface ApplyResponse {
  updated: number;
  errors: ApplyError[];
  summary: PreviewSummary;
}

// ---------------------------------------------------------------------------
// API Client
// ---------------------------------------------------------------------------

export const bulkBillingCodeApiClient = createApi({
  reducerPath: 'bulkBillingCodeApi',
  baseQuery: baseQueryWithErrorHandling,
  endpoints: (builder) => ({
    previewBulkBillingCode: builder.mutation<
      PreviewResponse,
      BulkBillingCodeRequest
    >({
      query: (body) => ({
        url: 'api/admin/bulk-billing-code/preview/',
        method: 'POST',
        body,
      }),
    }),
    applyBulkBillingCode: builder.mutation<
      ApplyResponse,
      BulkBillingCodeRequest
    >({
      query: (body) => ({
        url: 'api/admin/bulk-billing-code/apply/',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  usePreviewBulkBillingCodeMutation,
  useApplyBulkBillingCodeMutation,
} = bulkBillingCodeApiClient;
